import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {CHALLAN_ITEMS, HARDWARE_CHECKLIST, TS_LIST} from './type';

export const getHardwareInstall = (id, gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.hardwareInstall}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HARDWARE_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const postHardwareInstall = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveHardwareInstall}`
  );
  if (res) {
    return true;
  }
};

export const getChallansList = (mrfId,site_number,createdBy,page) => async (dispatch) => {
  dispatch({
    type: TS_LIST,
    payload: '',
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.materialRequistionForm.getChallans}?mrf_id=${mrfId}&site_number=${site_number}&createdBy=${createdBy}&challan_type=TO&page=${page}`
  );
  console.log(res)
  if (res) {
    const { data } = res;
    dispatch({
      type: TS_LIST,
      payload: data.response.data,
    });
    return true;
  } else {
    return false;
  }
};

export const getChallanItems = (id) => async (dispatch) => {
  dispatch({
    type: CHALLAN_ITEMS,
    payload: '',
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.materialRequistionForm.getChallanItems}?challan_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: CHALLAN_ITEMS,
      payload: data.response.data,
    });
    return true;
  }
};

export const saveMaterialReceive = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.materialRequistionForm.saveMaterialReceive}`
  );
  // console.log(res);
  if (res?.data?.response?.status == true) {
    return true;
  } else {
    return res?.data?.response?.message;
  }
};
